import { render } from "./CustomerReturns.vue?vue&type=template&id=be22801c&scoped=true"
import script from "./CustomerReturns.vue?vue&type=script&lang=js"
export * from "./CustomerReturns.vue?vue&type=script&lang=js"

import "./CustomerReturns.vue?vue&type=style&index=0&id=be22801c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be22801c"]])

export default __exports__